import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import React, { useEffect, useState } from "react"
import List from "../../../components/List/List"
import { couponMemory } from "../../../Objects/Memory/Memory"
import { CouponEntity } from "../../../Objects/Coupon/CouponEntity"
import { CouponsPupop } from "./CouponsPupop"
import { useGetCoupon } from "../../../hooks/Coupon/useGetCoupon"
import { EEnableStatusType } from "../../../Enum/EEnableStatusType"
import { useOnboardingCreatePopup } from "../../../hooks/useOnboardingCreatePopup"
import { useTranslation } from "react-i18next"
import { ImportDataPopup } from "../../../components/DataImport/ImportDataPopup"

export const CouponsPage: React.FC = () => {
  const { t } = useTranslation(["coupon", "list", "dataImport"])

  const [enable, setEnable] = useState(false)

  const [enableImport, setEnableImport] = useState(false)

  const [coupon, setCoupon] = useState<CouponEntity | undefined>(undefined)

  const { handleGetCoupon } = useGetCoupon()

  const handleSwitchEditeOrAdd = (status: boolean) => {
    setCoupon(undefined)

    setEnable(status)
  }

  useOnboardingCreatePopup(() => handleSwitchEditeOrAdd(true))

  const handleOpenEdite = (id: number) => {
    const entity = couponMemory.findById(id)!

    handleSwitchEditeOrAdd(true)

    setCoupon(entity)
  }

  const handleCopyCoupon = () => {
    if (!coupon) {
      return
    }

    setCoupon(new CouponEntity({ ...coupon, id: -1 }))
  }

  useEffect(() => {
    handleGetCoupon(() => {})
  }, [])

  return (
    <>
      <div className={defaultStyle.containerList}>
        <List
          enableLocalPagination
          messageCount={t("list:label_coupons_page_message_count")}
          messageEmpty={t("list:label_coupons_page_message_empty")}
          nameFindSearch={t("list:label_coupons_page_place_holder")}
          data={couponMemory.getListCards()}
          nameDropdown={Object.mapEnumToStrings(EEnableStatusType)}
          handleAddButton={() => handleSwitchEditeOrAdd(true)}
          handleImportFloatButton={() => setEnableImport(true)}
          handleRefreshButton={() => handleGetCoupon(() => {})}
          handleOnClick={(e) => handleOpenEdite(e)}
        />
      </div>

      {enable && (
        <CouponsPupop
          coupon={coupon}
          title={coupon && coupon.id !== -1 ? t("title_popup_edite") : t("title_popup_create")}
          onClonse={() => handleSwitchEditeOrAdd(false)}
          onCopy={handleCopyCoupon}
        />
      )}

      {enableImport && (
        <ImportDataPopup
          target="cupons"
          title={t("dataImport:title", { target: t("dataImport:target_coupons") })}
          onClose={() => setEnableImport(false)}
          onImported={() => handleGetCoupon(() => {})}
        />
      )}
    </>
  )
}
